import React, { useCallback, useContext } from 'react'
import { l } from '@manychat/manyui'

import { NextStep } from 'common/builder/components/chart/FlowChart/components/NextStep/NextStep'
import { AddTriggerButtonNew } from 'common/builder/components/chart/FlowChart/components/Node/StartingStep/AddTriggerButtonNew/AddTriggerButtonNew'
import { StartingStepHeader } from 'common/builder/components/chart/FlowChart/components/Node/StartingStep/StartingStepHeader/StartingStepHeader'
import { Trigger } from 'common/builder/components/chart/FlowChart/components/Node/StartingStep/Trigger/Trigger'
import { useFlowChartState } from 'common/builder/components/chart/FlowChart/contexts/FlowChartStateContext'
import { ServicesContext } from 'common/builder/components/chart/FlowChart/contexts/ServiceProvider'
import { FlowChartStartingStepNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartStartingStepNode'

import * as styles from './StartingStepContent.styles'

interface StartingStepContentProps {
  node: FlowChartStartingStepNode
}

export const StartingStepContent = ({ node }: StartingStepContentProps) => {
  const {
    data: {
      header: { title, icon },
      triggers,
      nextStep,
    },
  } = node

  const chartState = useFlowChartState()
  const { triggersService } = useContext(ServicesContext)

  const isCompactView = !chartState.isCreateTriggerAllowed && node.data.triggers.length === 0

  const handleTriggerClick = useCallback(
    (triggerId: string) => {
      triggersService?.selectTrigger(triggerId)
    },
    [triggersService],
  )

  const handleTriggerCreateClick = useCallback(() => {
    triggersService?.createTrigger()
  }, [triggersService])

  if (isCompactView) {
    return (
      <view style={styles.CompactViewWrapper}>
        <StartingStepHeader title={title} icon={icon} />
        <NextStep nextStep={nextStep} />
      </view>
    )
  }

  return (
    <view style={styles.NormalViewWrapper}>
      <view style={styles.HorizontalSpacer}>
        <StartingStepHeader title={title} icon={icon} />
        <view style={styles.ContentWrapper}>
          {triggers.length === 0 && (
            <richtext
              style={styles.EmptyNodeTextStyle}
              text={l.translate(
                'A Trigger is an event that starts your Automation.\n Click to add a Trigger.',
              )}
            />
          )}
          {triggers.map((trigger, idx) => (
            <Trigger
              key={idx}
              trigger={trigger}
              selected={chartState.selectedTrigger === trigger.id}
              activeStateIsVisible={chartState.isPublished}
              onClick={handleTriggerClick}
              isInteractionsDisabled={chartState.isNoInteractions}
            />
          ))}
          {chartState.isCreateTriggerAllowed && (
            <AddTriggerButtonNew muted={triggers.length >= 1} onClick={handleTriggerCreateClick} />
          )}
        </view>
      </view>
      <NextStep nextStep={nextStep} />
    </view>
  )
}
